/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-12-11",
    versionChannel: "nightly",
    buildDate: "2024-12-11T00:07:00.635Z",
    commitHash: "f24fcc2020309eff1fedb4b4529a4593b1eb2650",
};
